import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HomeOutsideIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-homeOutside"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M35 15a1 1 0 0 1 .993.883L36 16v16.001a2 2 0 0 1-1.85 1.994l-.149.005H9.999a2 2 0 0 1-1.994-1.85L8 32.001V17a1 1 0 0 1 1.993-.117L10 17v15h24V16a1 1 0 0 1 1-1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M18 32h8V21h-8z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          d="M22.738 0c-.43 0-.862.139-1.223.417L3.277 14.508a2.002 2.002 0 0 0-.312 2.865l1.558 1.866a1.996 1.996 0 0 0 2.758.301L22.695 7.632l14.97 11.932c.367.293.808.436 1.245.436.563 0 1.122-.236 1.516-.694l1.59-1.843a2 2 0 0 0-.27-2.87L23.986.436A2 2 0 0 0 22.737 0m0 2L40.5 16.157 38.911 18 22.714 5.09 6.058 17.957 4.5 16.091z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M15 2h-4a1 1 0 0 0-1 1v6.506a1 1 0 0 0 1.567.824l4-2.753A1 1 0 0 0 16 6.753V3a1 1 0 0 0-1-1m-1 1.999v2.228l-2 1.377V3.999zm47.096 7.314 1.114 1.66a33 33 0 0 0-2.816 2.113c-3.104 2.611-5.156 5.39-6.366 8.156a14.4 14.4 0 0 0-.877 2.625l-.066.314-.045.258-.029.199-.013.138-1.996-.123c.055-.886.382-2.356 1.194-4.212 1.331-3.044 3.568-6.074 6.91-8.885q1.105-.93 2.355-1.808z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M52 7.286V34h-2V7.286z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M40.904 11.313a35 35 0 0 1 2.989 2.243c3.343 2.81 5.58 5.84 6.91 8.884.765 1.748 1.1 3.152 1.182 4.05l.013.163-1.996.123-.014-.138-.049-.321-.055-.286-.035-.164a14.4 14.4 0 0 0-.877-2.625c-1.21-2.766-3.262-5.545-6.366-8.156a32 32 0 0 0-2.218-1.701l-.599-.411z"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M61.718 8.265c.092-.356.157-.723.157-1.107 0-2.47-2.029-4.474-4.53-4.474-.735 0-1.417.188-2.03.493A4.51 4.51 0 0 0 51 0a4.51 4.51 0 0 0-4.315 3.177 4.5 4.5 0 0 0-2.029-.493c-2.502 0-4.53 2.003-4.53 4.474 0 .384.063.751.156 1.107-2.193.576-3.782 2.265-3.782 4.261 0 2.471 2.434 4.474 5.437 4.474 1.523 0 2.897-.517 3.884-1.346 1.316.83 3.15 1.346 5.18 1.346s3.861-.517 5.177-1.346c.987.83 2.362 1.346 3.884 1.346 3.003 0 5.438-2.003 5.438-4.474 0-1.996-1.589-3.685-3.782-4.26"
        />
        <path
          fill="#fff"
          d="M59.5 27.5h-17a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M59.5 23h-17a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5m-17 1h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5"
        />
        <path fill="#fff" d="M59.5 31.5h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M59.5 29h-17a1.5 1.5 0 0 0-1.5 1.5l.008.145c.09.782.729 1.355 1.492 1.355h17a1.5 1.5 0 0 0 1.5-1.5l-.008-.145A1.507 1.507 0 0 0 59.5 29m-17 1h17a.5.5 0 0 1 .497.441l.004.088c-.001.247-.225.471-.501.471h-17a.5.5 0 0 1-.497-.441L42 30.47c.001-.247.225-.471.501-.471M44 32v2h-1v-2zM59 32v2h-1v-2z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M57 28v2h-1v-2zM46 28v2h-1v-2z"
        />
      </g>
    </Icon>
  )
}
